// Shared helpers used by extracted Admin tabs. Keep this lean — only true
// cross-tab utilities go here.

export const STATUS_OPTIONS = [
  "pending_payment", "paid", "printing", "ready", "completed", "cancelled",
];

export const STATUS_LABEL = {
  pending_payment: "Pending Payment",
  paid: "Paid",
  printing: "Printing",
  ready: "Ready",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const WORKFLOW_STATUSES = new Set(["printing", "ready", "completed"]);
export const PAYMENT_STATUSES = new Set(["pending_payment", "paid", "cancelled"]);

export function hasPerm(user, perm) {
  if (!user) return false;
  if (user.role === "super_admin" || user.role === "admin") return true;
  return (user.permissions || []).includes(perm);
}

// Hide all but the last 3 digits of a phone number, e.g. "0733 737 993" → "•••• ••• 993".
// Customers' contact info is PII — only staff with orders.view_pii (default: super_admin,
// dispatch, senior) see it in full.
export function maskPhone(phone) {
  if (!phone) return "—";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.length <= 3) return phone;
  const last = digits.slice(-3);
  return `•••• ••• ${last}`;
}

// Human-readable "how long ago" for an ISO timestamp. Falls back to a
// short absolute date once >7 days out. Used in the Orders list so staff
// can eyeball at a glance which orders are freshest.
export function timeAgo(iso) {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "—";
  const diffSec = Math.max(0, (Date.now() - then) / 1000);
  if (diffSec < 45) return "just now";
  if (diffSec < 90) return "1 min ago";
  const min = Math.round(diffSec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} h ago`;
  const days = Math.round(hr / 24);
  if (days < 7) return `${days} d ago`;
  return new Date(iso).toLocaleDateString("en-KE", { day: "2-digit", month: "short" });
}

// Absolute Nairobi timestamp for order detail pages. Format: "16 Jul 2026, 14:32 EAT".
export function fmtNairobi(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-KE", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
    hour12: false, timeZone: "Africa/Nairobi",
  }) + " EAT";
}
